import type { Location } from 'react-router';

export const FOCUSED_REQUEST_FOR_QUOTE_PARAM = 'requestForQuoteId';

export const REQUEST_FOR_QUOTE_REDIRECT_STATE = {
  fromRequestForQuoteRedirect: true,
};

export function isReachedThroughRequestForQuoteRedirect(
  locationState: unknown
): boolean {
  return (
    typeof locationState === 'object' &&
    locationState !== null &&
    'fromRequestForQuoteRedirect' in locationState &&
    locationState.fromRequestForQuoteRedirect === true
  );
}

export function isFirstHistoryEntry(location: Pick<Location, 'key'>): boolean {
  return location.key === 'default';
}

const VIEW_PARAM = 'view';
const REQUEST_VIEW = 'request';

export function buyListRequestForQuoteLink(
  buyListId: string,
  requestForQuoteId: string
): string {
  const search = new URLSearchParams({
    [FOCUSED_REQUEST_FOR_QUOTE_PARAM]: requestForQuoteId,
  });
  return `/buy-lists/view/${buyListId}?${search.toString()}`;
}

export function requestForQuoteOwnViewLink(requestForQuoteId: string): string {
  const search = new URLSearchParams({ [VIEW_PARAM]: REQUEST_VIEW });
  return `/rfq/view/${requestForQuoteId}?${search.toString()}`;
}

export function isRequestForQuoteOwnViewRequested(
  searchParams: URLSearchParams
): boolean {
  return searchParams.get(VIEW_PARAM) === REQUEST_VIEW;
}

export function comparedRequestRowElementId(requestForQuoteId: string): string {
  return `request-for-quote-${requestForQuoteId}`;
}
